import React, { useState, useEffect } from "react";
import axiosClient from "../../config/axiosClient";
import API_ENDPOINTS from "../../config/api";

const PaymentApprovalModal = ({ show, initialData, onClose, onSave }) => {
  const [formData, setFormData] = useState({
    id: 0,
    stepOrder: 1,
    approverId: "",
    position: 0,
    note: "",
    configGroup: "General",
    isCCOnly: false,
    isAttachmentRequired: false,
  });

  const [users, setUsers] = useState([]);

  useEffect(() => {
    if (show) {
      const fetchUsers = async () => {
        try {
          const res = await axiosClient.get(API_ENDPOINTS.users);
          setUsers(res.data || []);
        } catch (e) {
          console.error("❌ Failed to fetch user directory:", e);
        }
      };
      fetchUsers();
    }
  }, [show]);

  useEffect(() => {
    if (show) {
      if (initialData) {
        setFormData({
          id: initialData.id || 0,
          stepOrder: initialData.stepOrder || 1,
          approverId: initialData.approverId || "",
          position: initialData.position === "Staff" ? 0 : 
                    initialData.position === "Manager" ? 1 : 
                    initialData.position === "Director" ? 2 : 
                    parseInt(initialData.position) || 0,
          note: initialData.note || "",
          configGroup: initialData.configGroup || "General",
          isCCOnly: !!initialData.isCCOnly,
          isAttachmentRequired: !!(initialData.isAttachmentRequired || initialData.IsAttachmentRequired), 
        });
      } else {
        setFormData({
          id: 0,
          stepOrder: 1,
          approverId: "",
          position: 0,
          note: "",
          configGroup: "General",
          isCCOnly: false,
          isAttachmentRequired: false,
        });
      }
    }
  }, [initialData, show]);

  const handleSubmit = (e) => {
    e.preventDefault();
    
    const payload = {
      ...formData,
      id: parseInt(formData.id) || 0,
      approverId: formData.approverId ? parseInt(formData.approverId) : null,
      stepOrder: formData.stepOrder ? parseInt(formData.stepOrder) : 1,
      position: parseInt(formData.position),
      configGroup: "General",
      isAttachmentRequired: !!formData.isAttachmentRequired
    };

    console.log(">>> Submitting Payment Config Payload:", payload);
    onSave(payload);
  };

  if (!show) return null;

  return (
    <div className="modal d-block" style={{ backgroundColor: "rgba(0,0,0,0.5)", zIndex: 1050 }}>
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content border-0 shadow">
          <form onSubmit={handleSubmit}>
            <div className="modal-header bg-primary text-white">
              <h5 className="modal-title">
                {formData.id ? "Edit Payment Approval Step" : "Add Payment Approval Step"}
              </h5>
              <button type="button" className="btn-close btn-close-white" onClick={onClose}></button>
            </div>

            <div className="modal-body">
              <div className="row g-3">
                <div className="col-12">
                  <label className="form-label small fw-bold">Step Sequence Order</label>
                  <input 
                    type="number" 
                    className="form-control form-control-sm"
                    min="1"
                    required
                    value={formData.stepOrder}
                    onChange={(e) => setFormData({...formData, stepOrder: e.target.value})}
                  />
                </div>

                <div className="col-12">
                  <label className="form-label small fw-bold">Assign Specific Approver</label>
                  <select 
                    className="form-select form-select-sm"
                    value={formData.approverId || ""}
                    onChange={(e) => setFormData({...formData, approverId: e.target.value})}
                  >
                    <option value="">-- No Specific User --</option>
                    {users.map((u) => (
                      <option key={u.id} value={u.id}>{u.fullName || u.userName} ({u.email})</option>
                    ))}
                  </select>
                </div>

                <div className="col-12">
                  <label className="form-label small fw-bold">Required Authority Level (Position)</label>
                  <select 
                    className="form-select form-select-sm"
                    value={formData.position}
                    onChange={(e) => setFormData({...formData, position: parseInt(e.target.value)})}
                  >
                    <option value={0}>General Staff</option>
                    <option value={1}>Department Manager</option>
                    <option value={2}>Division Manager</option>
                    <option value={3}>Board of Directors</option>
                  </select>
                </div>

                <div className="col-12">
                  <label className="form-label small fw-bold">Purpose / Internal Instructions</label>
                  <textarea 
                    className="form-control form-control-sm" 
                    rows="2"
                    value={formData.note}
                    onChange={(e) => setFormData({...formData, note: e.target.value})}
                  />
                </div>

                {/* Trường Is CC Only đã được ẩn theo yêu cầu */}

                <div className="col-12">
                  <div className="form-check form-switch pt-2">
                    <input 
                      className="form-check-input" 
                      type="checkbox" 
                      id="isAttachmentRequired" 
                      checked={formData.isAttachmentRequired}
                      onChange={(e) => setFormData({...formData, isAttachmentRequired: e.target.checked})}
                    />
                    <label className="form-check-label small fw-bold text-secondary" htmlFor="isAttachmentRequired">
                      Require Attachment (Mandatory upload)
                    </label>
                  </div>
                </div>
              </div>
            </div>

            <div className="modal-footer bg-light">
              <button type="button" className="btn btn-secondary btn-sm" onClick={onClose}>Cancel</button>
              <button type="submit" className="btn btn-primary btn-sm px-4">
                {formData.id ? "Update Config Step" : "Save Config Step"}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default PaymentApprovalModal;